/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'gemini/app/util/ErrorUtils'
], function(ErrorUtils) {

	class ActionHandler {
		onSelectItem(context) {
			const glassContext = context.glassContext;

			const instrumentationSvc = glassContext.getCoreSvc('.Instrumentation');
			if(instrumentationSvc.enabled) {
				instrumentationSvc.track({
					type: 'Created Object',
					objectType: 'Story',
					action: 'created',
					milestoneName: 'created_Story' //action_objectType
				});
			}

			glassContext.appController.openAppView('createStory');
		}

		/**
		 * Determine whether to show the menu item
		 */
		isItemVisible(context) {
			return ErrorUtils.hasCapability(context.glassContext, 'canAuthorDashboard');
		}
	}

	return ActionHandler;
});
